import { create } from "zustand";

const initialState = {
  admin: null,
  user: null,
  permissions: [],
};

const useAppStore = create((set) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setAdmin: (admin) => set(() => ({ admin })),
  setUser: (user) => set(() => ({ user })),
  setPermissions: (permissions) =>
    set(() => ({ permissions: permissions || [] })),
}));

export default useAppStore;
